import {
  Box,
  Button,
  Divider,
  Drawer,
  IconButton,
  SwipeableDrawer,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useAppSelector, useAppDispatch } from "../hooks/hooks";
import { closeNftSelectionDrawer } from "../redux/nftSlice";
import CloseIcon from "@mui/icons-material/Close";

interface SelectNftProps {
  onSelect: (nft: any) => void;
}

const SelectNftsDialog: React.FC<SelectNftProps> = ({ onSelect }) => {
  const [loading, setLoading] = useState(false);
  const { nftSelectionDrawerOpen } = useAppSelector((state) => state.nft);
  const { nfts } = useAppSelector((state) => state.nft);
  const dispatch = useAppDispatch();

  const handleSubmit = async () => {
    setLoading(true);
  };

  const toggleDrawer = (isOpen: boolean) => () => {
    if (nftSelectionDrawerOpen) {
      dispatch(closeNftSelectionDrawer());
    }
  };

  const scrollableBoxStyles = {
    maxHeight: "20vh",
    overflowY: "auto",
    scrollbarWidth: "none", // For Firefox
    "&::-webkit-scrollbar": {
      display: "none", // For Chrome, Safari, and Opera
    },
  };

  return (
    // <SwipeableDrawer
    //   open={open}
    //   onClose={onClose}
    //   onOpen={() => {}}
    //   anchor="right"
    //   sx={{
    //     "& .MuiDrawer-paper": {
    //       width: { xs: "100%", sm: 400 },
    //       boxSizing: "border-box",
    //     },
    //   }}
    // >
    <Drawer
      anchor="bottom"
      open={nftSelectionDrawerOpen}
      onClose={() => dispatch(closeNftSelectionDrawer())}
      sx={{
        "& .MuiDrawer-paper": {
          width: { xs: "100%", sm: 500 },
          margin: "0 auto",
          borderTopLeftRadius: 12,
          borderTopRightRadius: 12,
          height: "auto",
          maxHeight: "60vh",
          boxSizing: "border-box",
          px: 2,
          pb: 2,
          pt: 1,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1,
        }}
      >
        <Typography variant="subtitle1">Add Token Attachment</Typography>
        <IconButton onClick={toggleDrawer(false)}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider sx={{ mb: 2 }} />
      {nfts.length === 0 && (
        <Box
          sx={{
            textAlign: "center",
            py: 4,
            minHeight: "200px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="body1">No NFTs available</Typography>
        </Box>
      )}

      {nfts.length > 0 && (
        <Box
          sx={{
            ...scrollableBoxStyles,
            pt: 2,
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          {nfts.map((nft) => (
            <Box
              key={nft.productId}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: 2,
                border: "1px solid #ccc",
                borderRadius: 1,
              }}
            >
              <img
                src={nft.displayImageUrl}
                alt={nft.name}
                width={150}
                height={150}
              />
              <span>{nft.name}</span>
              <Button
                variant="contained"
                color="primary"
                onClick={() => onSelect(nft)}
              >
                Select
              </Button>
            </Box>
          ))}
        </Box>
      )}
      {/*}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : "Select NFT"}
        </Button>
      </DialogActions> */}
    </Drawer>
  );
};

export default SelectNftsDialog;
